<template>
    <div class="no-more">
        {{ text || '没有更多了' }}
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: '没有更多了'
        }
    }
}
</script>

<style lang="scss" scoped>
.no-more{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    color: #969799;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/NoMore/index.vue